import React from 'react';

export const DolarIcon = ({ className }) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M12 1V2V3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12 21V22V23" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M19 7.5C19 6.90905 18.8707 6.32389 18.6194 5.77792C18.3681 5.23196 17.9998 4.73588 17.5355 4.31802C17.0712 3.90016 16.52 3.56869 15.9134 3.34254C15.3068 3.1164 14.6566 3 14 3H9.5C8.17392 3 6.90215 3.47411 5.96447 4.31802C5.02678 5.16193 4.5 6.30653 4.5 7.5C4.5 8.69347 5.02678 9.83807 5.96447 10.682C6.90215 11.5259 8.17392 12 9.5 12H15C16.3261 12 17.5979 12.4741 18.5355 13.318C19.4732 14.1619 20 15.3065 20 16.5C20 17.6935 19.4732 18.8381 18.5355 19.682C17.5979 20.5259 16.3261 21 15 21H9C7.67392 21 6.40215 20.5259 5.46447 19.682C4.52678 18.8381 4 17.6935 4 16.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>

	);
};
